document.addEventListener(
  'toggle',
  function (event) {
    const openedItem = event.target;

    if (!(openedItem instanceof HTMLDetailsElement)) return;

    const summary = openedItem.querySelector(':scope > summary');

    if (summary) {
      summary.setAttribute('aria-expanded', String(openedItem.open));
    }

    if (!openedItem.open) return;

    let accordionGroup;
    let accordionItems;

    // Product information accordions
    if (openedItem.closest('.product__accordion')) {
      accordionGroup = openedItem.closest('.product__info-container');

      accordionItems = accordionGroup?.querySelectorAll(
        '.product__accordion > details[open]'
      );
    }

    // FAQ and other Shopify collapsible-content sections
    else if (openedItem.closest('.collapsible-content__grid .accordion')) {
      accordionGroup = openedItem.closest('.collapsible-content__wrapper');

      accordionItems = accordionGroup?.querySelectorAll(
        '.collapsible-content__grid .accordion > details[open]'
      );
    }

    if (!accordionItems) return;

    accordionItems.forEach(function (item) {
      if (item !== openedItem) {
        item.open = false;

        const itemSummary = item.querySelector(':scope > summary');

        if (itemSummary) {
          itemSummary.setAttribute('aria-expanded', 'false');
        }
      }
    });
  },
  true
);